import type { ContractMode } from 'contexts/contract/interface'
import validation from 'utils/validation'
import * as yup from 'yup'

export const createChassiSchema = (type: ContractMode = 'CREATE') => {
    const requiredChassi = yup.string().trim().required()

    return type === 'CREATE'
        ? requiredChassi.test({
              name: 'invalid',
              test: value => !!value && validation.chassis(value)
          })
        : requiredChassi
}
